<template>
	<div class="tag" :style="{ backgroundColor: backgroundColor }">
		<template>
			<img
				class="tag__image"
				:src="icon"
				alt="tag icon"
			>
		</template>
		<template>
			<span class="tag__text">{{ text }}</span>
		</template>
	</div>
</template>

<script>
export default {
	name: "Tag",
	props: {
		backgroundColor: {
			type: String,
			default: "#BF4CBF"
		},
		icon: {
			type: String,
			default: ""
		},
		altIcon: {
			type: String,
			default: "Tag Icon"
		},
		text: {
			type: String,
			default: ""
		}
	}
};
</script>

<style lang="scss" scoped>
.tag {
	display: flex;
	height: 23px;
	align-items: center;
	border-radius: 2px;
	padding: 6px 8px 4px;

	img {
		width: 14px;
		height: 14px;
		margin-top: -2px;
		margin-right: 2px;
		vertical-align: text-top;
	}

	&__text {
		color: #fff;
		font-size: 12px;
		text-transform: uppercase;
		font-weight: bold;
		line-height: initial;
	}
}
</style>